import { useNavigate } from "react-router-dom";
import { formatearMoneda } from "../../funcionesDatos/Moneda";
import { formatearFechaCalendario, formatearFechaHora } from "../../funcionesDatos/fechas";


function ListaPagosVendedor({
    reservas = [],
    paginaActual = 1,
    totalPaginas = 1,
    totalReservas = 0,
    reservasPorPagina = 10,
    irPaginaAnterior,
    irPaginaSiguiente,
    idUsuario
}){

    const navigate = useNavigate();

    function obtenerImagenReserva(reserva) {
        return (
            reserva?.imagenes?.[0] ||
            reserva?.servicio?.imagenes?.[0] ||
            reserva?.servicio?.imagenesServicios?.[0] ||
            "/imagenes/marca/avatar.png"
        );
    }

    function obtenerNombreServicio(reserva) {
        return reserva?.servicio?.nombre || reserva?.nombreServicio || "Reserva";
    }

    function obtenerFechaReserva(reserva) {
        if(reserva?.fecha) return formatearFechaCalendario(reserva.fecha);
        if(reserva?.inicio) return formatearFechaHora(reserva.inicio);
        return "NA";
    }

    function obtenerEstadoPago(reserva) {
        if(reserva?.pagoVendedor?.estaRetenido) return "Retenido";
        if(reserva?.pagoVendedor?.estaPagado) return "Pagado";
        if(reserva?.pagoVendedor?.estaProgramado) return "Programado";
        if(reserva?.pagoVendedor?.estaDisponible) return "Disponible";
        return reserva?.desembolso?.estado || "Pendiente";
    }

    function claseEstadoPago(reserva) {
        const estado = obtenerEstadoPago(reserva).toLowerCase();

        if(estado === "pagado") return "bg-success-subtle text-success border border-success-subtle";
        if(estado === "programado") return "bg-primary-subtle text-primary border border-primary-subtle";
        if(estado === "disponible") return "bg-warning-subtle text-warning-emphasis border border-warning-subtle";
        if(estado === "retenido") return "bg-danger-subtle text-danger border border-danger-subtle";
        if(estado === "fallido") return "bg-danger-subtle text-danger border border-danger-subtle";

        return "bg-light text-secondary border";
    }

    function mostrarMoneda(valor, moneda = "COP") {
        return formatearMoneda(Number(valor || 0), moneda);
    }



    function verReserva(reserva) { 
        navigate("/vendedor/reserva", {
            state: {
                idReserva: reserva?._id,
                idUsuario: idUsuario,
                quienEs: "Vendedor"
            }

            


        });
    }

    const inicioPagina = (Number(paginaActual || 1) - 1) * Number(reservasPorPagina || 10);
    const finPagina = inicioPagina + Number(reservas?.length || 0);

    return(
        <div className="container">
            <div className="card border-0 shadow-sm rounded-4 overflow-hidden">
                <div className="card-header bg-white border-0 p-4 d-flex flex-column flex-md-row justify-content-between gap-2">
                    <div>
                        <h5 className="fw-bold mb-1">Reservas y pagos</h5>
                        <p className="text-secondary mb-0">Aquí puedes revisar las reservas completadas y el estado de pago de cada una.</p>
                    </div>

                    <div className="text-md-end">
                        <span className="badge rounded-pill bg-light text-dark border px-3 py-2">
                            {totalReservas} reserva(s)
                        </span>
                    </div>
                </div>

                <div className="card-body p-0">
                    {reservas.length === 0 ? (
                        <div className="p-4 text-center text-secondary">
                            Aún no tienes reservas completadas para mostrar en pagos.
                        </div>
                    ) : (
                        <div className="list-group list-group-flush">
                            {reservas.map((reserva) => {
                                const moneda = reserva?.cobro?.moneda || "COP";
                                const montoProveedor = reserva?.desembolso?.montoProveedor || 0;

                                return(
                                    <div className="list-group-item p-3 p-md-4" key={reserva?._id}>
                                        <div className="row align-items-center g-3">
                                            <div className="col-auto">
                                                <img
                                                    src={obtenerImagenReserva(reserva)}
                                                    alt={obtenerNombreServicio(reserva)}
                                                    className="rounded-4 object-fit-cover"
                                                    style={{ width: "76px", height: "76px" }}
                                                />
                                            </div>

                                            <div className="col-12 col-md">
                                                <div className="d-flex flex-wrap align-items-center gap-2 mb-1">
                                                    <h6 className="fw-bold mb-0">{obtenerNombreServicio(reserva)}</h6>
                                                    <span className={`badge rounded-pill px-3 py-2 ${claseEstadoPago(reserva)}`}>
                                                        {obtenerEstadoPago(reserva)}
                                                    </span>
                                                </div>

                                                <div className="text-secondary small">
                                                    <span className="me-3"><strong>Fecha:</strong> {obtenerFechaReserva(reserva)}</span>
                                                    <span className="me-3"><strong>Paquete:</strong> {reserva?.tipoPaquete || "NA"}</span>
                                                    <span><strong>Reserva:</strong> {String(reserva?._id || "NA").slice(-8)}</span>
                                                </div>
                                            </div>

                                            <div className="col-6 col-md-auto text-md-end">
                                                <span className="text-secondary small d-block">A recibir</span>
                                                <strong className="fs-5">{mostrarMoneda(montoProveedor, moneda)}</strong>
                                            </div>

                                            <div className="col-6 col-md-auto text-end">
                                                <button
                                                    type="button"
                                                    className="btn btn-outline-primary rounded-pill px-3"
                                                    onClick={() => verReserva(reserva)}
                                                >
                                                    Ver reserva
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                );
                            })}
                        </div>
                    )}
                </div>

                <div className="card-footer bg-white border-0 p-3 d-flex flex-column flex-md-row align-items-center justify-content-between gap-3">
                    <small className="text-secondary">
                        Mostrando {reservas.length > 0 ? inicioPagina + 1 : 0} - {finPagina} de {totalReservas}
                    </small>

                    <div className="d-flex align-items-center gap-2">
                        <button
                            type="button"
                            className="btn btn-light border rounded-pill px-3"
                            disabled={Number(paginaActual || 1) <= 1}
                            onClick={irPaginaAnterior}
                        >
                            Anterior
                        </button>

                        <span className="small text-secondary">
                            Página {paginaActual} de {totalPaginas}
                        </span>

                        <button
                            type="button"
                            className="btn btn-light border rounded-pill px-3"
                            disabled={Number(paginaActual || 1) >= Number(totalPaginas || 1)}
                            onClick={irPaginaSiguiente}
                        >
                            Siguiente
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}


export default ListaPagosVendedor;